module.exports = __webpack_public_path__ + "static/media/header-entries.625516a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/entries/header-entries.jpg
// module id = 676
// module chunks = 0